import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';
import RichText from 'components/RichText';
import EmbedCode from '@servicetitan/website-common/src/Contentful/EmbedCode';

const ContentfulEmbedCode = ({ embedCode, displayCode }) => {
  if (!embedCode) {
    return null;
  }

  const code = embedCode;
  const innerCode = JSON.parse(code?.raw).content[0]?.content[0]?.value;
  if (displayCode === 'Head' && innerCode) {
    return <Helmet>{parse(innerCode)}</Helmet>;
  }
  if (displayCode === 'Script') {
    return <EmbedCode displayCode={displayCode} embedCode={innerCode} />;
  }
  return (
    <SectionLayout>
      <EmbedCodeContainer>
        <RichText content={code} />
      </EmbedCodeContainer>
    </SectionLayout>
  );
};

ContentfulEmbedCode.propTypes = {
  code: PropTypes.object,
};

export default ContentfulEmbedCode;

const EmbedCodeContainer = styled.div`
  display: flex;
  justify-content: center;

  span {
    display: contents;
  }
`;
